import type { EventProperties, TrackEventOptions } from './types';

const getTherapistSlug = (): string | undefined => {
  const match = window.location.pathname.match(/^\/therapists\/([^/]+)$/);
  return match?.[1];
};

export const emit = (
  eventName: string,
  properties?: EventProperties,
  options?: TrackEventOptions
): void => {
  const therapistSlug = getTherapistSlug();
  const merged: EventProperties = {
    ...(therapistSlug ? { therapist_slug: therapistSlug } : {}),
    ...properties,
  };

  const excluded = options?.exclude ?? [];

  if (window.gtag && !excluded.includes('gtag')) {
    window.gtag('event', eventName, merged);
  }

  if (window.posthog && !excluded.includes('posthog')) {
    window.posthog.capture(eventName, merged);
  }
};
